export enum EKey {
  preference = 'mp_pref',
  redirect = 'mp_rd',
  token = 'mp_tk',
  refresh_token = 'mp_rt'
}
